/** Chronicle lines, alarms and their codes in Italian (ADR 0025): the same texts on screen
 *  (web, i18next) and on paper (the PDF of the report, i18next on the server). */
export const chronicleIt = {
  kinds: {
    alarm: 'allarme',
    status: 'stato',
    assignment: 'assegnazione',
    communication: 'comunicazione',
    media: 'media',
    position: 'posizione',
    resource: 'risorsa',
    event: 'evento',
    note: 'nota',
  },
  events: {
    operation_opened: 'Apertura operazione · livello {{level}}',
    operation_closed: 'Chiusura operazione · cronaca sigillata',
    alert_level_changed: 'Livello di allertamento da {{from}} a {{to}}',
    sectors_assigned: '{{count}} settori assegnati alle squadre {{teams}}',
    drone_in_flight: 'Drone in volo sul settore {{sector}}, quota {{altitude}} m',
    coc_gym_available: 'Palestra comunale disponibile come punto di raccolta',
    team_assigned_sector: 'Squadra {{team}} assegnata al settore {{sector}}',
    sector_completed: 'Settore {{sector}} completato al {{pct}}%',
    node_unreachable: 'Nodo {{node}} non raggiungibile',
    team_returning: 'Squadra {{team}} in rientro verso il PCA',
    photo_from_field: 'Foto dal campo — {{note}}',
    battery_critical: 'Batteria del Field al {{pct}}%',
    position_updated: 'Posizione aggiornata nel settore {{sector}}, quadrante {{quadrant}}',
    sos_received: 'SOS ricevuto dal settore {{sector}}',
    post_opened: 'Apertura presidio · livello {{level}}',
    bulletin_received: 'Bollettino regionale ricevuto',
    hourly_reading: 'Lettura oraria registrata: {{value}}',
    hydro_level: 'Livello idrometrico {{value}}',
    drill_opened: 'Apertura esercitazione · livello {{level}}',
    base_camp_ready: 'Campo base completato',
    triage_ready: 'Triage allestito, {{count}} figuranti registrati',
    alarm_acknowledged: '{{code}} preso in carico da {{by}}',
    alarm_closed: '{{code}} chiuso',
    team_status_changed: 'Squadra {{team}}: nuovo stato «{{status}}»',
    team_created: 'Squadra {{team}} ({{code}}) creata · persone: {{people}}',
    team_tracker_assigned: 'Tracker {{device}} assegnato alla squadra {{team}}',
    team_transferred_in: 'Squadra {{team}} ({{code}}) arrivata da {{from}}',
    team_transferred_out: 'Squadra {{team}} ({{code}}) passata a {{to}}',
    team_headcount_changed: 'Squadra {{team}}: persone da {{from}} a {{to}}',
    team_dogs_changed: 'Squadra {{team}}: cani da {{from}} a {{to}}',
    team_sector_changed: 'Squadra {{team}}: settore {{sector}}',
    team_sector_cleared: 'Squadra {{team}}: settore da assegnare',
    team_radio_changed: 'Squadra {{team}}: canale radio {{channel}}',
    team_radio_cleared: 'Squadra {{team}}: canale radio della missione',
    team_member_added: '{{person}} nella squadra {{team}}',
    team_member_removed: '{{person}} esce dalla squadra {{team}}',
    team_tracker_released: 'Tracker {{device}} tolto alla squadra {{team}}',
    team_dissolved: 'Squadra {{team}} ({{code}}) sciolta',
    team_restored: 'Squadra {{team}} ({{code}}) ripristinata',
    manual_note: '{{text}}',
    unknown: 'Evento {{key}}',
    resource_assigned: "Risorsa {{code}} · {{name}} assegnata all'operazione",
    resource_released: "Risorsa {{code}} · {{name}} tolta dall'operazione",
    map_area_drawn: '{{code}} «{{name}}» disegnato sulla mappa',
    map_grid_created: 'Griglia di ricerca {{code}}: {{cells}} celle da {{cellM}} m',
    map_grid_removed: 'Griglia di ricerca {{code}} rimossa ({{cells}} celle)',
    map_sector_assigned: 'Settore {{sector}} assegnato a {{team}}',
    map_sector_unassigned: 'Settore {{sector}} senza squadra',
    map_element_deleted: '{{code}} «{{name}}» eliminato dalla mappa',
    map_element_restored: '{{code}} «{{name}}» ripristinato sulla mappa',
    station_unreachable: 'Postazione {{station}} non raggiungibile',
    alarm_resolved: '{{code}} rientrato: {{subject}} di nuovo raggiungibile',
    station_band_full: 'Postazione {{station}} in linea su {{link}}, banda piena',
    station_band_reduced:
      'Postazione {{station}} su {{link}}: banda ridotta, video del drone e radar sospesi',
    station_band_minimal:
      'Postazione {{station}} su {{link}}: banda minima, sospesi anche gli allegati video',
    station_band_offline: 'Postazione {{station}} senza collegamento',
    field_check_in: '{{who}}: tutto ok',
    field_report_person_found: 'Segnalazione dal campo · persona trovata: {{text}}',
    field_report_hazard: 'Segnalazione dal campo · pericolo: {{text}}',
    field_report_damage: 'Segnalazione dal campo · danno: {{text}}',
    field_report_resource_needed: 'Segnalazione dal campo · risorsa necessaria: {{text}}',
    field_report_other: 'Segnalazione dal campo: {{text}}',
    field_sos_raised: 'SOS da {{operator}} con Sentinel Field',
    field_sos_false_alarm:
      "{{operator}} segnala che l'SOS era un errore: l'allarme resta aperto finché la sala non lo chiude",
    field_phone_revoked: 'Telefono {{code}} «{{label}}» scollegato da Sentinel Field',
    sensor_ordinary: '{{sensor}} a {{value}} {{unit}}: superata la soglia ordinaria',
    sensor_moderate: '{{sensor}} a {{value}} {{unit}}: superata la soglia moderata',
    sensor_high: '{{sensor}} a {{value}} {{unit}}: superata la soglia elevata',
    sensor_back_below: '{{sensor}} a {{value}} {{unit}}: di nuovo sotto le soglie',
    operation_opened_continuing: 'Apertura operazione · livello {{level}} · continua {{continues}}',
    operation_closed_outcome:
      'Chiusura operazione · $t(chronicle.outcomes.{{outcome}}) · cronaca sigillata',
    reference_point_set:
      'Punto di riferimento fissato · {{coords}} · $t(chronicle.referenceSources.{{source}})',
    reference_point_set_device:
      'Punto di riferimento fissato · {{coords}} · posizione del dispositivo ± {{accuracyM}} m',
    reference_point_removed: 'Punto di riferimento rimosso: posizione da fissare',
    area_laid:
      'Area tracciata sul punto · raggio {{radius}} · $t(chronicle.sectorsCount, {"count": {{sectors}} })',
  },
  referenceSources: {
    search: 'dalla ricerca',
    map: 'scelto sulla mappa',
    device: 'posizione del dispositivo',
  },
  outcomes: {
    positive: 'esito positivo',
    negative: 'esito negativo',
    concluded: 'intervento concluso',
    drill_concluded: 'esercitazione conclusa',
    cancelled: 'annullata',
  },
  sectorsCount_zero: 'nessun settore',
  sectorsCount_one: '{{count}} settore',
  sectorsCount_other: '{{count}} settori',
  alarms: {
    sos_operator: '{{operator}}, {{code}}, settore {{sector}}. Richiede presa in carico nominale.',
    battery_critical:
      '{{team}} al {{pct}}%. Pianificare il cambio o il rientro entro {{minutes}} minuti.',
    node_offline:
      '{{node}} non risponde da {{minutes}} minuti. Il settore {{sector}} resta scoperto.',
    sensor_threshold: '{{sensor}} a {{value}}, {{gap}} sotto la soglia di attenzione.',
    external_alert: '{{source}}: criticità ordinaria confermata.',
    no_criticality: 'Nessuna criticità attiva. Prossimo scenario alle {{next}}.',
    unknown: 'Allarme {{key}}',
    station_offline:
      '{{station}} non si sente da {{minutes}} minuti: il posto di comando potrebbe essere senza collegamento.',
    field_sos:
      '{{operator}} ({{code}}) ha chiesto aiuto da Sentinel Field. Richiede presa in carico nominale.',
    sensor_ordinary: '{{sensor}} a {{value}} {{unit}}, sopra la soglia ordinaria.',
    sensor_moderate: '{{sensor}} a {{value}} {{unit}}, sopra la soglia moderata.',
    sensor_high: '{{sensor}} a {{value}} {{unit}}, sopra la soglia elevata.',
  },
  codes: {
    'ALL-01': 'SOS operatore',
    'ALL-02': 'Uomo a terra',
    'ALL-03': 'Mancato check-in radio',
    'ALL-04': 'Perdita contatto GPS',
    'ALL-05': 'Uscita da zona operativa',
    'ALL-06': 'Batteria critica risorsa',
    'ALL-07': 'Nodo o gateway offline',
    'ALL-08': 'Soglia sensore superata',
    'ALL-09': 'Drone: link perso o rientro',
    'ALL-10': 'Degrado copertura LoRa',
    'ALL-11': 'Allerta esterna',
    'ALL-12': 'Servizio Sentinel degradato',
  },
  level: 'L{{level}}',
  status: {
    open: 'Aperto',
    acknowledged: 'Preso in carico',
    closed: 'Chiuso',
  },
} as const;
